// collectionThunks.js
import { onSnapshot, query, where, orderBy, limit } from 'firebase/firestore';
import { fetchItemsStart, fetchItemsSuccess, fetchItemsFailure, fetchItemsStartOnAir, fetchItemsSuccessOnAir, fetchItemsFailureOnAir } from './collectionSlice';
import { RankListRequestRef, ScoringRequest } from '../../firebase/collections';

// This thunk now accepts collectionName and optional query parameters
 const thirtyMinutesAgo = new Date();
    thirtyMinutesAgo.setMinutes(thirtyMinutesAgo.getMinutes() - 30);
export const subscribeToTempRank = (showID) => (dispatch) => {
  dispatch(fetchItemsStart());
  try {
    const q = query(
      RankListRequestRef,
      where("ShowId", "==", showID),
      where("TimeStamp", ">=", thirtyMinutesAgo),
      orderBy('TimeStamp', 'desc'),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      dispatch(fetchItemsSuccess(data));
    }, (error) => {
      console.error("Firestore subscription error:", error);
      dispatch(fetchItemsFailure(error.message));
    });

    return unsubscribe;

  } catch (error) {
    console.error("Error setting up subscription:", error);
    dispatch(fetchItemsFailure(error.message));
  }
};
export const subscribeToHorseOnAir = (showID) => (dispatch) => {
  dispatch(fetchItemsStartOnAir());
  try {
    const q = query(
      ScoringRequest,
      where("ShowId", "==", showID),
      where("TimeStamp", ">=", thirtyMinutesAgo),
      orderBy('TimeStamp', 'desc'),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      dispatch(fetchItemsSuccessOnAir(data));
    }, (error) => {
      console.error("Firestore subscription error:", error);
      dispatch(fetchItemsFailureOnAir(error.message));
    });

    return unsubscribe;

  } catch (error) {
    console.error("Error setting up subscription:", error);
    dispatch(fetchItemsFailureOnAir(error.message));
  }
};